import * as React from 'react';
import { SVGProps } from 'react';

const IconSolverHydraulicsSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.259 14.467c.271-.299.64-.467 1.023-.467.515 0 .992.302 1.25.793l.229.432C10.995 17.562 13.264 19 15.718 19c1.828 0 3.58-.8 4.873-2.224L23 14.12l-1.144-1.26-2.335 2.5c-.98 1.05-2.309 1.639-3.695 1.639-1.86 0-3.58-1.06-4.516-2.781l-.235-.432C10.475 12.68 9.37 12 8.174 12c-.89 0-1.745.379-2.374 1.053l-2.354 2.52 1.404 1.548 2.409-2.654Zm-5.115-.328L1 12.879l2.409-2.655C4.7 8.8 6.454 8 8.282 8c2.454 0 4.723 1.438 5.957 3.775l.228.432c.26.491.736.793 1.25.793.385 0 .753-.168 1.024-.467l2.409-2.654 1.404 1.548-2.354 2.52A3.249 3.249 0 0 1 15.826 15c-1.195 0-2.3-.68-2.901-1.787l-.235-.432C11.754 11.059 10.034 10 8.174 10c-1.386 0-2.715.59-3.695 1.639l-2.335 2.5Z"
      fill="var(--color-control-typo-ghost)"
    />
    <path d="M19.25 8V6.2H13V3.8h6.25V2L23 5l-3.75 3Z" fill="#91C2A6" />
  </svg>
);
export default IconSolverHydraulicsSizeM;
